const EXP_LOCALSTORAGE_PREFIX = "__exp.";
const BST_LOCALSTORAGE_PREFIX = "bst.";
const ENVIRONMENT = "env";
const LOCAL_STORAGE_CONSTANTS = {
  enableMsalTesting: "enableMsalTesting"
};
const wpsExperimentationGroup = "wpsExperimentationGroup";
const VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTIN = "redirect_To_MetricsAuthoring_OptIn";
const VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTOUT = "redirect_To_MetricsAuthoring_OptOut";
const PREVIEW_SCORECARD_USER_OPTED_IN_INITIAL_STAGE = "preview_Scorecard_User_Opted_In_Initial_Stage";
const PREVIEW_SCORECARD_USER_OPTED_OUT_INTERMEDIATE_STAGE = "preview_Scorecard_User_Opted_In_Intermediate_Stage";
const METRICSET_SUBSCRIBER_PICKER_BUBBLE_DISMISSED = "metricset_Subscriber_Picker_Bubble_Is_Dismissed";
const METRICSET_SHARE_PICKER_BUBBLE_DISMISSED = "metricset_Share_Picker_Bubble_Dismissed";
const METRICSET_NEW_PREVIEW_EXPERIENCE_BUBBLE_DISMISSED = "metricset_New_Preview_Experience_Bubble_Is_Dismissed";
export {
  BST_LOCALSTORAGE_PREFIX,
  ENVIRONMENT,
  EXP_LOCALSTORAGE_PREFIX,
  LOCAL_STORAGE_CONSTANTS,
  METRICSET_NEW_PREVIEW_EXPERIENCE_BUBBLE_DISMISSED,
  METRICSET_SHARE_PICKER_BUBBLE_DISMISSED,
  METRICSET_SUBSCRIBER_PICKER_BUBBLE_DISMISSED,
  PREVIEW_SCORECARD_USER_OPTED_IN_INITIAL_STAGE,
  PREVIEW_SCORECARD_USER_OPTED_OUT_INTERMEDIATE_STAGE,
  VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTIN,
  VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTOUT,
  wpsExperimentationGroup
};
//# sourceMappingURL=LocalStorage.constants.js.map
